import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { printSeparatedList } from '../slang-printers/print-separated-list.js';
import { SlangNode } from './SlangNode.js';
import { ErrorParameter } from './ErrorParameter.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { AstPath, Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class ErrorParameters extends SlangNode {
  readonly kind = NonterminalKind.ErrorParameters;

  items: ErrorParameter[];

  constructor(ast: ast.ErrorParameters, collected: CollectedMetadata) {
    super(ast, collected, true);

    this.items = ast.items.map((item) => new ErrorParameter(item, collected));
  }

  print(print: PrintFunction, path: AstPath<ErrorParameters>): Doc {
    return this.items.length > 0
      ? printSeparatedList(path.map(print, 'items'))
      : '';
  }
}
